import React, { useState } from 'react';
import { doc, setDoc, Timestamp, collection } from 'firebase/firestore';
import { db, appId } from '../firebase';
import { Card, Button } from '../components/UI';
import { interventionPlans } from '../helpers/interventionPlans';

const ActivityCheckbox = ({ activity, isChecked, onToggle }) => (
    <div 
        onClick={() => onToggle(activity.id)}
        className="flex items-start space-x-3 p-3 bg-white rounded-lg cursor-pointer border hover:border-sky-500 transition-colors"
    >
        <div className={`mt-1 flex-shrink-0 w-5 h-5 rounded-full border-2 flex items-center justify-center ${isChecked ? 'bg-brand-purple border-brand-purple' : 'border-gray-300'}`}>
            {isChecked && <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}><path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" /></svg>}
        </div>
        <p className={`text-brand-dark ${isChecked ? 'font-semibold' : ''}`}>{activity.text}</p>
    </div>
);

export default function CreateInterventionScreen({ user, child, navigate, showToast }) {
    const [selectedActivities, setSelectedActivities] = useState({});
    const [notes, setNotes] = useState('');
    const [loading, setLoading] = useState(false);
    
    const planType = 'perkembangan'; // For now, we only focus on developmental intervention
    const availableActivities = interventionPlans[planType].activities;

    const handleToggleActivity = (activityId) => {
        setSelectedActivities(prev => ({
            ...prev,
            [activityId]: !prev[activityId]
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const chosenActivities = availableActivities.filter(act => selectedActivities[act.id]);
        if (chosenActivities.length === 0) {
            showToast("Pilih minimal satu aktivitas intervensi.", "error");
            return;
        }
        setLoading(true);
        try {
            const planRef = doc(collection(db, `children/${child.id}/interventionPlans`));
            await setDoc(planRef, {
                id: planRef.id,
                planType,
                title: interventionPlans[planType].title,
                description: interventionPlans[planType].description,
                activities: chosenActivities,
                notes,
                status: 'active',
                createdBy: user.uid,
                createdAt: Timestamp.now(),
                progress: {} // To be filled by parent
            });
            showToast("Rencana intervensi berhasil dibuat!");
            navigate('viewChild', child);
        } catch (error) {
            console.error("Error creating intervention plan:", error);
            showToast("Gagal membuat rencana.", "error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Card>
            <h2 className="text-2xl font-bold text-brand-dark mb-1">Buat Rencana Intervensi</h2>
            <p className="text-brand-muted mb-6">Untuk anak: <span className="font-semibold">{child.name}</span></p>

            <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                    <h3 className="font-bold text-brand-dark mb-2">Pilih Aktivitas Intervensi</h3>
                    <div className="space-y-3 max-h-60 overflow-y-auto p-2 bg-gray-50 rounded-lg">
                        {availableActivities.map(activity => (
                            <ActivityCheckbox 
                                key={activity.id}
                                activity={activity}
                                isChecked={!!selectedActivities[activity.id]}
                                onToggle={handleToggleActivity}
                            />
                        ))}
                    </div>
                </div>

                <div>
                    <label htmlFor="notes" className="block text-sm font-bold text-brand-dark mb-2">Catatan Tambahan untuk Orang Tua</label>
                    <textarea
                        id="notes"
                        value={notes}
                        onChange={(e) => setNotes(e.target.value)}
                        rows="3"
                        placeholder="Contoh: Lakukan aktivitas motorik halus di pagi hari selama 15 menit."
                        className="input-field"
                    ></textarea>
                </div>
                
                <Button type="submit" disabled={loading}>{loading ? 'Menyimpan...' : 'Simpan & Tugaskan Rencana'}</Button>
            </form>
        </Card>
    );
}
